import React, { useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { IPOLStats } from '../../api/interfaces'
import { IChart, IChartConfig } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'
import { colors } from '../../const'

export async function getReservePolDeploymentsConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_reserve_pol_stats', timeframe)) as IPOLStats[]
	const pools = ['AVAX.AVAX', 'BCH.BCH', 'BSC.BNB', 'BTC.BTC', 'DOGE.DOGE', 'ETH.USDT-0XDAC17F958D2EE523A2206206994597C13D831EC7', 'LTC.LTC']
	const assetData: IPOLStats[][] = []
	const seriesData: { x: number; y: number }[][] = []
	const config: IChart[] = []
	pools.forEach((pool) => {
		assetData.push(chartData.filter((row) => row.POOL_NAME === pool))
	})
	assetData.forEach((asset) => {
		seriesData.push(
			asset.map((element: IPOLStats) => {
				return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_DEPOSITED_RUNE - element.TOTAL_WITHDRAWN_RUNE }
			})
		)
	})
	const series1 = assetData[3].map((element: IPOLStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_CURRENT_VALUE_RUNE }
	})
	const series5 = (() => {
		const sumByDay = new Map<number, number>()

		for (const series of [seriesData[0], seriesData[1], seriesData[2], seriesData[3], seriesData[4], seriesData[5], seriesData[6]]) {
			for (const { x, y } of series) {
				sumByDay.set(x, (sumByDay.get(x) ?? 0) + y)
			}
		}

		return Array.from(sumByDay, ([x, y]) => ({ x, y })).sort((a, b) => a.x - b.x)
	})()
	config.push({
		data: series1,
		strokeWidth: 2,
		name: `Current Value`,
		type: 'line',
		seriesGroup: ' [rune]',
		color: `${color}`,
		unitSymbol: 'ᚱ'
	})
	config.push({
		data: series5,
		strokeWidth: 2,
		name: `Total Deposited`,
		type: 'line',
		seriesGroup: '[rune]',
		color: `${colors[0]}`,
		unitSymbol: 'ᚱ'
	})
	let i = 0
	seriesData.forEach((series) => {
		config.push({
			data: series,
			strokeWidth: 2,
			name: pools[i].split('-')[0].toUpperCase(),
			type: 'line',
			seriesGroup: '[rune]',
			color: colors[i + 1],
			unitSymbol: 'ᚱ'
		})
		i++
	})

	return { config: config, latestValue: 0, latestValueDate: 0 }
}

const ReservePolDeployments = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getReservePolDeploymentsConfig, '1m')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Total Net Reserve POL Deployments"
			chartDesc={`Total Reserve POL deployments subtracted by withdrawals stacked by recipient pool.\n Tracking address: thor1dheycdevq39qlkxs2a6wuuzyn4aqxhve4qxtxt`}
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="88fdb846-eb56-4576-bcf0-af576c4443e0"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			hasLogScale={false}
			sortByValueDesc={true}
		/>
	)
}

export default ReservePolDeployments
